import React from 'react';
import $ from 'jquery';
import { withReferer } from 'plugins/contextual-back';
import { columnWidth, renderList } from 'utils/async-list';
import { Column } from 'react-virtualized';
import { renderCaseCustomer } from '../cases/common';
import { displayConfirmModalIfNeeded } from './confirm-validation';
import { error } from 'plugins/toastr';
import fetch from 'utils/fetch';

function getFetchAction($button) {
  const url = $button.attr('data-action');
  const method = $button.attr('data-method') || 'POST';

  if (url && url.length) {
    return () =>
      fetch(url, {
        method,
      }).then(res => {
        $button.removeClass('loading');
        location.reload();
      });
  }

  return null;
}

const handleValidateTableClick = (evt, hasRights) => {
  evt.preventDefault();
  evt.stopPropagation();

  // Serialize ids as JSON and execute given URL
  const $button = $(evt.currentTarget);
  const $action = getFetchAction($button);
  displayConfirmModalIfNeeded(hasRights, () => {
    $button.addClass('loading');
    $action().catch(err => {
      console.log('Error attempting to execute selection action', err);

      const errorHeader = err.res.headers.get('errorCustom');
      let errorLabel;

      if (errorHeader) {
        errorLabel = errorHeader;
      } else {
        errorLabel =
          "Une erreur est survenue pendant la sauvegarde de l'intervention";
      }

      $button.removeClass('loading');
      error(errorLabel);
    });
  });
};

const renderValidateAction = ({ rowData }) => {
  const id = rowData.id;

  const renderButton = (
    <a
      className="ui basic green button selection validation"
      onClick={evt => handleValidateTableClick(evt, rowData.hasUserWithRights)}
      data-id={id}
      data-action={`/pco-manager/aast/cases/interventions/${id}/validate`}
      data-method="POST"
    >
      <i className="checkmark icon" />
      Valider
    </a>
  );

  const renderBlocking = (
    <a
      className="ui basic red button selection validation"
      onClick={handleValidateTableClick}
      data-id={id}
      data-action={`/pco-manager/aast/cases/interventions/${id}/validate`}
      data-method="POST"
    >
      <i className="warning sign icon" />
      Valider
    </a>
  );

  return rowData.isBlocking ? renderBlocking : renderButton;
};

function renderColumns(width) {
  return [
    <Column
      key="id"
      dataKey="id"
      cellRenderer={renderValidateAction}
      width={columnWidth(width, 2)}
      label="Action"
      disableSort
    />,
    <Column
      key="name"
      dataKey="name"
      cellRenderer={renderCaseCustomer}
      width={columnWidth(width, 7)}
      label="Nom du chantier"
    />,
    <Column
      key="executionDate"
      dataKey="executionDate"
      width={columnWidth(width, 7)}
      label="Date"
    />,
  ];
}

function render(url, from) {
  const caseUrl = id => {
    const components = id.split('_');

    if (components[0] === 'AAST-CASE') {
      return withReferer(
        `/pco-manager/aast/cases/${components[1]}/study`,
        from
      );
    } else if (components[0] === 'AAST-INTER') {
      return withReferer(
        `/pco-manager/aast/cases/interventions/${components[1]}`,
        from
      );
    }
  };

  const rowClickedUrl = id => caseUrl(id);
  const loadNextUrl = url;

  renderList(rowClickedUrl, loadNextUrl, renderColumns);
}

export default function list(ctx) {
  render(
    '/pco-manager/aast/interventions/notvalidated.json',
    '/pco-manager/aast/interventions/notvalidated'
  );
}



// WEBPACK FOOTER //
// ./src/modules/saas/aast/interventions/list-notvalidated.js